module.exports = __webpack_public_path__ + "img/wooten-logo.5e75de47.jpg";